import React, { useContext } from "react";
import { ThemeContext } from "./ThemeProvider";
import { Tooltip, IconButton, Zoom } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Brightness3, WbSunny } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  iconButton: {
    position: "fixed",
    bottom: theme.spacing(6),
    right: theme.spacing(6),
    height: "2.5rem",
    width: "2.5rem",
    // Add a responsive rule for mobile screens
    [theme.breakpoints.down("sm")]: {
      bottom: 'auto',
      right: 'auto',
      left: '1.5rem',
      top: '92%',
    },
  },
  icon: {
    fontSize: "1.25rem",
  },
}));

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const classes = useStyles();

  return (
    <Tooltip title="Toggle theme" placement="right" TransitionComponent={Zoom}>
      <IconButton
        color="inherit"
        onClick={toggleTheme}
        aria-label="Toggle theme"
        className={classes.iconButton}
      >
        {theme === "light" ? (
          <Brightness3 className={classes.icon} />
        ) : (
          <WbSunny className={classes.icon} />
        )}
      </IconButton>
    </Tooltip>
  );
};
